<!-- eslint-disable -->
<template>
    <span>{{calculatedLabelName}}</span>
</template>

<script>
/* eslint-disable */
export default {
  name: "c9SysNameLabel",
  components: {},
  props: ["systemUid", "isNameNeeded"],
  data() {
    return {
      objectMetaData: {},
      systemObjectUid: null
    };
  },
  mounted() {
    this.$nextTick(function() {
      this.objectMetaData = window.G_watchdog_data.IV_objects_meta_data;
      if (this.systemUid !== null && this.systemUid !== undefined) {
        this.systemObjectUid = this.systemUid.replace("sys_", "obj_");
      }
    });
  },
  watch: {
    systemUid() {
      if (this.systemUid !== null && this.systemUid !== undefined) {
        this.systemObjectUid = this.systemUid.replace("sys_", "obj_");
      }
    },
    objectMetaData() {
      if (this.isNameNeeded === undefined || this.isNameNeeded === false) {
        return;
      }
      if (this.systemObjectUid !== null && 
          this.systemObjectUid !== undefined &&
          this.systemObjectUid in this.objectMetaData && 
          'name' in this.objectMetaData[this.systemObjectUid]) {
        var name = this.objectMetaData[this.systemObjectUid]['name'];
        this.$emit("event-system-name-changed", name);
      }
    }
  },
  computed: {
    calculatedLabelName() {
      // human readable name
      if (this.systemUid !== null && 
          this.systemObjectUid in this.objectMetaData && 
          this.objectMetaData[this.systemObjectUid] !== null &&
          this.objectMetaData[this.systemObjectUid] !== undefined &&
          'name' in this.objectMetaData[this.systemObjectUid]) {
        return this.objectMetaData[this.systemObjectUid]['name'];
      // uid in case we can't look up human readable name
      } else if (
        this.systemUid !== null && this.systemUid !== undefined && 
        this.objectMetaData[this.systemObjectUid] !== null &&
        this.objectMetaData[this.systemObjectUid] !== undefined &&
        ( this.systemObjectUid in this.objectMetaData === false || 
          'name' in this.objectMetaData[this.systemObjectUid] === false )
        ) {
        return `Loading: ${this.systemUid}`
      } else {
        return "Loading..."
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Labels/c9SysNameLabel.vue